export default "__VITE_ASSET__BGWGe1Bk__"